import { render } from "./header-top.vue?vue&type=template&id=36dc4b3b"
import script from "./header-top.vue?vue&type=script&lang=js"
export * from "./header-top.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nathan/Dev/justcuts-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__